import React from 'react';
import { cn } from './cn';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  header?: React.ReactNode;
  footer?: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({ className, header, footer, children, ...props }) => (
  <div className={cn('ds-card', className)} {...props}>
    {header ? <div className="ds-card__header">{header}</div> : null}
    <div className="ds-card__body">{children}</div>
    {footer ? <div className="ds-card__footer">{footer}</div> : null}
  </div>
);
